import { FanguardApiContractsJobJobDetailMessage, NotificationExtended } from 'src/api/generated';

import createStore from './createStore';

interface Job {
  jobId: string;
  messages: FanguardApiContractsJobJobDetailMessage[];
  failedItems: number;
  successItems: number;
  totalItems: number;
  complete?: boolean;
  failed?: boolean;
}

export interface NotificationsState {
  notifications: NotificationExtended[];
  jobId: string;
  jobs: Job[];
}

const initialState: NotificationsState = {
  notifications: [],
  jobId: '',
  jobs: [],
};

export const notificationsStore = createStore(initialState);

export const getAllJobs = () => {
  return notificationsStore.getSnapshot().jobs;
};

export const addNotification = (notification: Partial<NotificationExtended>) => {
  if (notification && notification.message) {
    notificationsStore.setState((prevState) => ({
      ...prevState,
      notifications: [notification as NotificationExtended, ...prevState.notifications],
    }));
  }
};

export const clearAllNotifications = () => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    notifications: [],
  }));
};

export const clearNotification = (index: number) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    notifications: prevState.notifications.filter((_, i) => i !== index),
  }));
};

export const clearNotificationById = (id: string) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    notifications: prevState.notifications.filter((notification) => notification.id !== id),
  }));
};

export const findNotificationById = (id: string) => {
  return notificationsStore.getSnapshot().notifications.find((notification) => notification.id === id);
};

export const addJob = (job: Job) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: [...prevState.jobs, job],
  }));
};

export const updateJobFailedNumber = (jobId: string) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: prevState.jobs.map((job) => (job.jobId === jobId ? { ...job, failedItems: job.failedItems + 1 } : job)),
  }));
};

export const updateJobSuccessNumber = (jobId: string) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: prevState.jobs.map((job) => (job.jobId === jobId ? { ...job, successItems: job.successItems + 1 } : job)),
  }));
};

export const updateJobMessages = (jobId: string, message: FanguardApiContractsJobJobDetailMessage) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: prevState.jobs.map((job) => (job.jobId === jobId ? { ...job, messages: [message, ...job.messages] } : job)),
  }));
};

export const updateJobComplete = (jobId: string) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: prevState.jobs.map((job) => (job.jobId === jobId ? { ...job, complete: true } : job)),
  }));
};

export const updateJobFailed = (jobId: string) => {
  notificationsStore.setState((prevState) => ({
    ...prevState,
    jobs: prevState.jobs.map((job) => (job.jobId === jobId ? { ...job, complete: true, failed: true } : job)),
  }));
};
